
import React from "react";
import { FiMapPin, FiArrowLeft } from "react-icons/fi";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"

const LocationPage = ({
  locationError,
  requestLocation,
  locationLoading,
}) => {
  return (
    <section className="fw-screen fw-screen--plain fw-screen--location fw-fade">

     <div className="fw-brandmain">
          <img 
            src={fundwalelogo} 
            alt="Fundswalle" 
            className="fw-brand__logo1" 
          />
        </div>
      {/* Location Icon */}
      <div className="fw-location__icon">
        <FiMapPin />
      </div>

      {/* Content */}
      <div className="fw-location__content">
        <h1>Allow Location Access</h1>

        <p className="fw-location__description">
          We need access to your location
          <br />
          to fetch the best loan offers
          <br />
          available in your area.
        </p>

        <p className="fw-location__secure">
          Your location data is secure
          <br />
          and never shared.
        </p>
      </div>

      {locationError && (
        <p className="fw-error fw-location__error">
          {locationError}
        </p>
      )}

      {/* Bottom Button */}
      <div className="fw-screen__footer fw-location__footer">
        <button
          type="button"
          className="fw-btn fw-btn--location fw-btn--full"
          onClick={requestLocation}
          disabled={locationLoading}
        >
          {locationLoading ? "Requesting..." : "Proceed"}
        </button>
      </div>

    </section>
  );
};

export default LocationPage;